import Phaser from 'phaser';
import { queueRealAssets } from '../registry/assetManifest';
import { generatePlaceholderTextures } from '../registry/textures';
import { getLocalPhoto } from '../data/personalization';
import { TX } from '../registry/keys';

/** Preload: load any real asset files (none in Tier 1) + the Tiled map, then
 *  generate placeholder textures for every key not already loaded. */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('Preload');
  }

  preload(): void {
    const w = this.scale.width;
    const h = this.scale.height;
    this.add.rectangle(w / 2, h / 2, 184, 14, 0x000000, 0.35);
    const bar = this.add.rectangle(w / 2 - 88, h / 2, 4, 8, 0x7dbf5a).setOrigin(0, 0.5);
    this.load.on('progress', (p: number) => {
      bar.width = 4 + 172 * p;
    });

    queueRealAssets(this.load);
    this.load.tilemapTiledJSON('farm', 'assets/tiles/farm.json');
  }

  create(): void {
    generatePlaceholderTextures(this);
    // The family photo is device-local user data — load it from localStorage if set.
    const photo = getLocalPhoto();
    if (photo && !this.textures.exists(TX.photo)) {
      try {
        this.textures.addBase64(TX.photo, photo);
      } catch {
        /* ignore a bad/blank photo */
      }
    }
    this.scene.start('Title');
  }
}
